/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_S2_DInputs */

const en_mk_abt_s2_d = /** @type {(inputs: Mk_Abt_S2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our focus now is not new big features but making what exists feel light: readability, speed and removing steps that need not exist.`)
};

const id_mk_abt_s2_d = /** @type {(inputs: Mk_Abt_S2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus kami sekarang bukan menambah fitur besar, melainkan membuat yang ada terasa ringan: keterbacaan, kecepatan, dan mengurangi langkah yang tidak perlu.`)
};

/**
* | output |
* | --- |
* | "Our focus now is not new big features but making what exists feel light: readability, speed and removing steps that need not exist." |
*
* @param {Mk_Abt_S2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_s2_d = /** @type {((inputs?: Mk_Abt_S2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_S2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_s2_d(inputs)
	return en_mk_abt_s2_d(inputs)
});